export const DEFAULT_WORKSPACE_ID = "2";
export const DEFAULT_APPLICATION_ID = "app_17004310880732";

export const DEFAULT_RANKING_OPTIONS = {
  similarity_threshold: {
    enabled: false,
    value: 50,
    min: 0,
    max: 100,
    postfix: "%",
  },
  recency: { enabled: false, value: 0, min: 0, max: 2, postfix: "x" },
  prevalence: { enabled: false, value: 1, min: 0, max: 2, postfix: "x" },
  endorsed: { enabled: true, value: 1, min: 0, max: 2, postfix: "x" },
  favorited: { enabled: false, value: 0, min: 0, max: 2, postfix: "x" },
  bookmarked: { enabled: false, value: 0, min: 0, max: 2, postfix: "x" },
};
